<template>
  <div class="box">
    <span class="actions">
      <button>
        <md-icon>expand</md-icon>
      </button>
      <button>
        <md-icon>minimize</md-icon>
      </button>
      <button>
        <md-icon>close</md-icon>
      </button>
    </span>
    <Searchbar />
    <Schematic />
    <Filters />
    <Results />
  </div>
</template>
<script>
import Searchbar from '@/components/search/Searchbar'
import Schematic from '@/components/search/Schematic'
import Filters from '@/components/search/Filters'
import Results from '@/components/search/Results'

export default {
  components: {
    Searchbar,
    Schematic,
    Filters,
    Results,
  },
}
</script>

<style scoped>
.box {
  display: inline-block;
  min-width: 60%;
  width: 65%;
  max-width: 100%;
  margin: 1%;
  border: solid 1px black;
}
</style>
